/* Edit child lookup table */

// import './detail-form/detail-form.css';
import '@progress/kendo-ui';

import { orderBy, process } from '@progress/kendo-data-query';
import { Grid, GridColumn, GridToolbar } from '@progress/kendo-react-grid';
import * as _ from 'lodash';
import * as React from 'react';
import { Button, ButtonGroup, ButtonToolbar, Modal, Row, Well } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { push } from 'react-router-redux';
import { compose } from 'redux';
import { connectRequest } from 'redux-query';

import * as MutateActions from '../actions/mutate';
import * as AppComp from '../common/app-component-base';
import { BootstrapColXl as Col } from '../common/bootstrap/bootstrapcolxl';
import { Formatters } from '../common/formatters';
import * as KendoWrappers from '../common/kendoforms/componentwrappers';
import { NavigationLinks } from '../common/navigation';
import { WhiteBoxPageSection } from '../common/whiteboxpagesection';
import ApiEndpoints from '../config/apiendpoints';
import * as LK from '../config/apilookupkeys';
import * as DetailFormCommon from '../inventory/detail-form/common';
import * as ReduxQueries from '../queries';
import EditGridCommandCell from './edit-grid-command-cell';

export interface IEditChildLookupTableProps extends AppComp.IAppComponentProps {
    forceRequest?: any;
    lookups?: any;
    navigateTo?: any;
    tableName?: any;
    updateLookupObj?: any;
    deleteLookupObj?: any;
    newLookupObj?: any;
}

export interface IEditChildLookupTableState extends AppComp.IAppComponentState {
    editData?: any;
    addNewData?: any;
    additionalGridData?: any;
    formChanges?: any;
    gridSort?: any;
    showModalDeleteLookupObj: boolean;
}

class EditChildLookupTable extends AppComp.AppComponent<IEditChildLookupTableProps, IEditChildLookupTableState> {
    public readonly GridEditField: string = 'editField';
    public readonly GridNewRecordField: string = 'newRecordField';
    public readonly GridHideRecordField: string = 'hideRecordField';

    public constructor(props: IEditChildLookupTableProps) {
        super(props, 'app.lookup-tables.');

        this.state = {
            editData: {},
            addNewData: false,
            additionalGridData: undefined,
            formChanges: {},
            gridSort: undefined,
            showModalDeleteLookupObj: false,
        };
    }

    // BUTTON HANDLERS
    public handleEnterEdit(d: any) {
        this.setState({
            editData: _.cloneDeep(d),
            additionalGridData: undefined
        });
    }

    public handleEnterDetails(d: any) {
        // console.log('handleEnterDetails', { d });
        // this.props.navigateTo(NavigationLinks.lookupTableEditChildObj(tableName, childObjId));
    }

    public handleAddNewButtonDisabled(e: any) {
        let result = false;

        switch (e) {
            case LK.LookupKeys.ComponentLocations:
                result = true;
                break;

            default:
                result = false;
                break;
        }

        return result;
    }

    public handleAddNewButton(e: any) {
        let addNewLookupObj = {
            name: '',
            description: '',
            _id: '_new_associationType',
            associationTypeId: undefined,
            [this.GridEditField]: true,
            [this.GridNewRecordField]: true,
            [this.GridHideRecordField]: false,
        };

        this.setState({
            addNewData: true,
            editData: addNewLookupObj,
            additionalGridData: addNewLookupObj
        });
    }

    public handleConfirmRemove() {
        const { tableName } = this.props;
        const token = _.get(this.props, 'authsession.access_token', '');

        const curEdit = _.get(this.state, 'editData', {});
        const obj = _.omit(curEdit, 'deleteAssocTypeDestId');
        const destObj = { _id: Formatters.getStr(curEdit, 'deleteAssocTypeDestId') };
        const changeData = _.merge(
            {},
            { obj: obj },
            { tableName: tableName },
            { destObj: destObj },
        );

        this.props.deleteLookupObj(changeData, token, false).then(response => {
            // We can promise-chain on the mutation action to trigger state
            // transitions when it succeeds or fails.

            if (response.status >= 200 && response.status < 300) {
                this.setState({
                    editData: {},
                    addNewData: false,
                    additionalGridData: undefined,
                    showModalDeleteLookupObj: false,
                });
                this.props.forceRequest();
            } else {
                // Error during creation...
            }
        });
    }

    public handleSave(d: any) {
        const { tableName } = this.props;

        const token = _.get(this.props, 'authsession.access_token', '');

        const changeData = _.merge(
            {},
            { obj: d },
            { tableName: tableName },
        );

        this.props.updateLookupObj(changeData, token, false).then(response => {
            // We can promise-chain on the mutation action to trigger state
            // transitions when it succeeds or fails.

            if (response.status >= 200 && response.status < 300) {
                this.setState({
                    editData: {},
                    addNewData: false,
                    additionalGridData: undefined,
                });
                this.props.forceRequest();
            } else {
                // Error during creation...
            }
        });
    }

    public handleCreate(d: any) {
        const { tableName } = this.props;

        const token = _.get(this.props, 'authsession.access_token', '');

        const changeData = _.merge(
            {},
            { obj: d },
            { tableName: tableName },
        );

        this.props.newLookupObj(changeData, token, false).then(response => {
            // We can promise-chain on the mutation action to trigger state
            // transitions when it succeeds or fails.

            if (response.status >= 200 && response.status < 300) {
                this.setState({
                    editData: {},
                    addNewData: false,
                    additionalGridData: undefined,
                });
                this.props.forceRequest();
            } else {
                // Error during creation...
            }
        });
    }

    public handleCancel(d: any) {
        this.setState({
            editData: {},
            addNewData: false,
            additionalGridData: undefined,
        });
    }

    public handleGridItemChange(e: any) {
        let prev = _.cloneDeep(_.get(this.state, 'editData', {}));

        let n = Formatters.getStr(e, 'field');
        let v = _.get(e, 'value');

        if (!n) { return; }

        _.set(prev, n, v);

        this.setState({ editData: prev });
    }

    public handleBackButton(e: any) {
        this.props.navigateTo(NavigationLinks.lookupTables());
    }

    public handleShowModalDeleteLookupObj(e: any, selectedDataItem: any) {
        this.setState({ showModalDeleteLookupObj: true, editData: _.cloneDeep(selectedDataItem) });
    }

    public handleCloseModalDeleteLookupObj() {
        this.setState({ showModalDeleteLookupObj: false, editData: {} });
    }

    // HELPERS
    public getGridCol(fieldName: string, colTitle: string, colOptions: any = {}) {
        const result = _.merge(
            {},
            {
                f: fieldName,
                t: colTitle,
                p: colOptions,
            });

        return result;
    }

    // RENDERS
    public renderHeaderButtonToolbar() {
        return (
            <div>
                <Well className="header-well-buttontoolbar">
                    <Row>
                        <Col xs={3}>
                            <ButtonToolbar>
                                <ButtonGroup>
                                    <Button bsSize="sm" bsStyle="info" onClick={e => { this.handleBackButton(e); }}><i className="fa fa-database" /> {this.appText('lookup-tables')}</Button>
                                </ButtonGroup>
                            </ButtonToolbar>
                        </Col>
                    </Row>
                </Well>
            </div>
        );
    }

    public renderGridCol(c: any, i?: any) {
        let props: any = {
            key: `col-${i}`,
        };

        if (Formatters.getStr(c, 'f')) { _.merge(props, { field: Formatters.getStr(c, 'f') }); }
        if (Formatters.getStr(c, 't')) { _.merge(props, { title: Formatters.getStr(c, 't') }); }
        if (_.get(c, 'p', {})) { _.merge(props, _.get(c, 'p', {})); }

        let result = (<GridColumn {...props} />);

        return result;
    }

    public renderModalDeleteLookupObj = (formData: any) => {
        const { tableName, ...rest } = this.props;

        const defaultInputProps = { colLabelXs: 4, colInputXs: 7 };

        const inputProps = _.merge({}, defaultInputProps, {
            onChange: (n, v) => { console.log({ n, v }); },
        });

        const inputPropsVirtualizedSelect = _.merge({}, defaultInputProps, {
            className: 'inventory-detail-input-full-width',
        });

        const curEditData = _.get(this.state, 'editData', {});
        let lookupObjName = ''; // `${Formatters.getStr(curEditData, 'name')} (${Formatters.getStr(curEditData, 'associationTypeId')})`;
        let modalTitle = ''; // this.appText('modals.delete-lookup-obj.association-types.title');
        let modalNote = ''; // this.appText('modals.delete-lookup-obj.association-types.note');
        let modalSuccessButtonText = '';
        let disabled = (Formatters.getStr(curEditData, 'deleteAssocTypeDestId') === '') ? true : false;

        let modalBody = (<div />);
        switch (tableName) {
            case LK.LookupKeys.AssociationTypes: {
                lookupObjName = `${Formatters.getStr(curEditData, 'name')} (${Formatters.getStr(curEditData, 'associationTypeId')})`;
                modalTitle = this.appText('modals.delete-lookup-obj.association-types.title');
                modalNote = this.appText('modals.delete-lookup-obj.association-types.note');
                modalSuccessButtonText = this.appText('modals.delete-lookup-obj.association-types.delete-object');
                modalBody = (
                    <div>
                        <div className="lookup-tables-modal-delete-lookup-obj-warning-containter">
                            {modalNote}
                        </div>

                        <div>
                            {this.appText('modals.delete-lookup-obj.association-types.note-2')}
                        </div>

                        <div>
                            <DetailFormCommon.InventoryDetailFormSection title="">
                                <KendoWrappers.KendoDisabledInputHidden
                                    name="deleteLookupObj.targetAssociationType"
                                    label={this.appText('modals.delete-lookup-obj.association-types.pending-deletion')}
                                    value={lookupObjName}
                                    {...inputProps}
                                />
                                <KendoWrappers.KendoDropdownListInput
                                    name="deleteLookupObj.destObjId"
                                    clearable={false}
                                    label={this.appText('modals.delete-lookup-obj.association-types.choose-default-type')}
                                    value={_.get(this.state, 'editData.deleteAssocTypeDestId')}
                                    data={_.get(formData, 'options.associationTypes')}
                                    textField="text"
                                    valueField="value"
                                    onChange={(o) => {
                                        const newVal = _.get(o, 'target.value');
                                        let ed = _.get(this.state, 'editData');
                                        ed.deleteAssocTypeDestId = newVal;
                                        this.setState({ editData: ed });
                                    }}
                                    {...inputPropsVirtualizedSelect}
                                />
                            </DetailFormCommon.InventoryDetailFormSection>
                        </div>
                    </div>
                );
                break;
            }

            case LK.LookupKeys.ClientTypes: {
                lookupObjName = `${Formatters.getStr(curEditData, 'name')} (${Formatters.getStr(curEditData, 'clientTypeId')})`;
                modalTitle = this.appText('modals.delete-lookup-obj.client-types.title');
                modalNote = this.appText('modals.delete-lookup-obj.client-types.note');
                modalSuccessButtonText = this.appText('modals.delete-lookup-obj.client-types.delete-object');
                modalBody = (
                    <div>
                        <div className="lookup-tables-modal-delete-lookup-obj-warning-containter">
                            {modalNote}
                        </div>

                        <div>
                            {this.appText('modals.delete-lookup-obj.client-types.note-2')}
                        </div>

                        <div>
                            <DetailFormCommon.InventoryDetailFormSection title="">
                                <KendoWrappers.KendoDisabledInputHidden
                                    name="deleteLookupObj.targetClientType"
                                    label={this.appText('modals.delete-lookup-obj.client-types.pending-deletion')}
                                    value={lookupObjName}
                                    {...inputProps}
                                />
                                <KendoWrappers.KendoDropdownListInput
                                    name="deleteLookupObj.destObjId"
                                    clearable={false}
                                    label={this.appText('modals.delete-lookup-obj.client-types.choose-default-type')}
                                    value={_.get(this.state, 'editData.deleteAssocTypeDestId')}
                                    data={_.get(formData, 'options.clientTypes')}
                                    textField="text"
                                    valueField="value"
                                    onChange={(o) => {
                                        const newVal = _.get(o, 'target.value');
                                        let ed = _.get(this.state, 'editData');
                                        ed.deleteAssocTypeDestId = newVal;
                                        this.setState({ editData: ed });
                                    }}
                                    {...inputPropsVirtualizedSelect}
                                />
                            </DetailFormCommon.InventoryDetailFormSection>
                        </div>
                    </div>
                );
                break;
            }

            case LK.LookupKeys.RoofTypes: {
                lookupObjName = `${Formatters.getStr(curEditData, 'name')} (${Formatters.getStr(curEditData, 'roofTypeId')})`;
                modalTitle = this.appText('modals.delete-lookup-obj.roof-types.title');
                modalNote = this.appText('modals.delete-lookup-obj.roof-types.note');
                modalSuccessButtonText = this.appText('modals.delete-lookup-obj.roof-types.delete-object');
                modalBody = (
                    <div>
                        <div className="lookup-tables-modal-delete-lookup-obj-warning-containter">
                            {modalNote}
                        </div>

                        <div>
                            {this.appText('modals.delete-lookup-obj.roof-types.note-2')}
                        </div>

                        <div>
                            <DetailFormCommon.InventoryDetailFormSection title="">
                                <KendoWrappers.KendoDisabledInputHidden
                                    name="deleteLookupObj.targetRoofType"
                                    label={this.appText('modals.delete-lookup-obj.roof-types.pending-deletion')}
                                    value={lookupObjName}
                                    {...inputProps}
                                />
                                <KendoWrappers.KendoDropdownListInput
                                    name="deleteLookupObj.destObjId"
                                    clearable={false}
                                    label={this.appText('modals.delete-lookup-obj.roof-types.choose-default-type')}
                                    value={_.get(this.state, 'editData.deleteAssocTypeDestId')}
                                    data={_.get(formData, 'options.roofTypes')}
                                    textField="text"
                                    valueField="value"
                                    onChange={(o) => {
                                        const newVal = _.get(o, 'target.value');
                                        let ed = _.get(this.state, 'editData');
                                        ed.deleteAssocTypeDestId = newVal;
                                        this.setState({ editData: ed });
                                    }}
                                    {...inputPropsVirtualizedSelect}
                                />
                            </DetailFormCommon.InventoryDetailFormSection>
                        </div>
                    </div>
                );
                break;
            }

            case LK.LookupKeys.FencingTypes: {
                lookupObjName = `${Formatters.getStr(curEditData, 'name')} (${Formatters.getStr(curEditData, 'fencingTypeId')})`;
                modalTitle = this.appText('modals.delete-lookup-obj.fencing-types.title');
                modalNote = this.appText('modals.delete-lookup-obj.fencing-types.note');
                modalSuccessButtonText = this.appText('modals.delete-lookup-obj.fencing-types.delete-object');
                modalBody = (
                    <div>
                        <div className="lookup-tables-modal-delete-lookup-obj-warning-containter">
                            {modalNote}
                        </div>

                        <div>
                            {this.appText('modals.delete-lookup-obj.fencing-types.note-2')}
                        </div>

                        <div>
                            <DetailFormCommon.InventoryDetailFormSection title="">
                                <KendoWrappers.KendoDisabledInputHidden
                                    name="deleteLookupObj.targetFencingType"
                                    label={this.appText('modals.delete-lookup-obj.fencing-types.pending-deletion')}
                                    value={lookupObjName}
                                    {...inputProps}
                                />
                                <KendoWrappers.KendoDropdownListInput
                                    name="deleteLookupObj.destObjId"
                                    clearable={false}
                                    label={this.appText('modals.delete-lookup-obj.fencing-types.choose-default-type')}
                                    value={_.get(this.state, 'editData.deleteAssocTypeDestId')}
                                    data={_.get(formData, 'options.fencingTypes')}
                                    textField="text"
                                    valueField="value"
                                    onChange={(o) => {
                                        const newVal = _.get(o, 'target.value');
                                        let ed = _.get(this.state, 'editData');
                                        ed.deleteAssocTypeDestId = newVal;
                                        this.setState({ editData: ed });
                                    }}
                                    {...inputPropsVirtualizedSelect}
                                />
                            </DetailFormCommon.InventoryDetailFormSection>
                        </div>
                    </div>
                );
                break;
            }

            case LK.LookupKeys.SidingTypes: {
                lookupObjName = `${Formatters.getStr(curEditData, 'name')} (${Formatters.getStr(curEditData, 'sidingTypeId')})`;
                modalTitle = this.appText('modals.delete-lookup-obj.siding-types.title');
                modalNote = this.appText('modals.delete-lookup-obj.siding-types.note');
                modalSuccessButtonText = this.appText('modals.delete-lookup-obj.siding-types.delete-object');
                modalBody = (
                    <div>
                        <div className="lookup-tables-modal-delete-lookup-obj-warning-containter">
                            {modalNote}
                        </div>

                        <div>
                            {this.appText('modals.delete-lookup-obj.siding-types.note-2')}
                        </div>

                        <div>
                            <DetailFormCommon.InventoryDetailFormSection title="">
                                <KendoWrappers.KendoDisabledInputHidden
                                    name="deleteLookupObj.targetSidingType"
                                    label={this.appText('modals.delete-lookup-obj.siding-types.pending-deletion')}
                                    value={lookupObjName}
                                    {...inputProps}
                                />
                                <KendoWrappers.KendoDropdownListInput
                                    name="deleteLookupObj.destObjId"
                                    clearable={false}
                                    label={this.appText('modals.delete-lookup-obj.siding-types.choose-default-type')}
                                    value={_.get(this.state, 'editData.deleteAssocTypeDestId')}
                                    data={_.get(formData, 'options.sidingTypes')}
                                    textField="text"
                                    valueField="value"
                                    onChange={(o) => {
                                        const newVal = _.get(o, 'target.value');
                                        let ed = _.get(this.state, 'editData');
                                        ed.deleteAssocTypeDestId = newVal;
                                        this.setState({ editData: ed });
                                    }}
                                    {...inputPropsVirtualizedSelect}
                                />
                            </DetailFormCommon.InventoryDetailFormSection>
                        </div>
                    </div>
                );
                break;
            }

            case LK.LookupKeys.SecuredTypes: {
                lookupObjName = `${Formatters.getStr(curEditData, 'name')} (${Formatters.getStr(curEditData, 'securedTypeId')})`;
                modalTitle = this.appText('modals.delete-lookup-obj.secured-types.title');
                modalNote = this.appText('modals.delete-lookup-obj.secured-types.note');
                modalSuccessButtonText = this.appText('modals.delete-lookup-obj.secured-types.delete-object');
                modalBody = (
                    <div>
                        <div className="lookup-tables-modal-delete-lookup-obj-warning-containter">
                            {modalNote}
                        </div>

                        <div>
                            {this.appText('modals.delete-lookup-obj.secured-types.note-2')}
                        </div>

                        <div>
                            <DetailFormCommon.InventoryDetailFormSection title="">
                                <KendoWrappers.KendoDisabledInputHidden
                                    name="deleteLookupObj.targetSecuredType"
                                    label={this.appText('modals.delete-lookup-obj.secured-types.pending-deletion')}
                                    value={lookupObjName}
                                    {...inputProps}
                                />
                                <KendoWrappers.KendoDropdownListInput
                                    name="deleteLookupObj.destObjId"
                                    clearable={false}
                                    label={this.appText('modals.delete-lookup-obj.secured-types.choose-default-type')}
                                    value={_.get(this.state, 'editData.deleteAssocTypeDestId')}
                                    data={_.get(formData, 'options.securedTypes')}
                                    textField="text"
                                    valueField="value"
                                    onChange={(o) => {
                                        const newVal = _.get(o, 'target.value');
                                        let ed = _.get(this.state, 'editData');
                                        ed.deleteAssocTypeDestId = newVal;
                                        this.setState({ editData: ed });
                                    }}
                                    {...inputPropsVirtualizedSelect}
                                />
                            </DetailFormCommon.InventoryDetailFormSection>
                        </div>
                    </div>
                );
                break;
            }

            case LK.LookupKeys.RecRoomTypes: {
                lookupObjName = `${Formatters.getStr(curEditData, 'name')} (${Formatters.getStr(curEditData, 'recRoomTypeId')})`;
                modalTitle = this.appText('modals.delete-lookup-obj.rec-room-types.title');
                modalNote = this.appText('modals.delete-lookup-obj.rec-room-types.note');
                modalSuccessButtonText = this.appText('modals.delete-lookup-obj.rec-room-types.delete-object');
                modalBody = (
                    <div>
                        <div className="lookup-tables-modal-delete-lookup-obj-warning-containter">
                            {modalNote}
                        </div>

                        <div>
                            {this.appText('modals.delete-lookup-obj.rec-room-types.note-2')}
                        </div>

                        <div>
                            <DetailFormCommon.InventoryDetailFormSection title="">
                                <KendoWrappers.KendoDisabledInputHidden
                                    name="deleteLookupObj.targetrecRoomType"
                                    label={this.appText('modals.delete-lookup-obj.rec-room-types.pending-deletion')}
                                    value={lookupObjName}
                                    {...inputProps}
                                />
                                <KendoWrappers.KendoDropdownListInput
                                    name="deleteLookupObj.destObjId"
                                    clearable={false}
                                    label={this.appText('modals.delete-lookup-obj.rec-room-types.choose-default-type')}
                                    value={_.get(this.state, 'editData.deleteAssocTypeDestId')}
                                    data={_.get(formData, 'options.recRoomTypes')}
                                    textField="text"
                                    valueField="value"
                                    onChange={(o) => {
                                        const newVal = _.get(o, 'target.value');
                                        let ed = _.get(this.state, 'editData');
                                        ed.deleteAssocTypeDestId = newVal;
                                        this.setState({ editData: ed });
                                    }}
                                    {...inputPropsVirtualizedSelect}
                                />
                            </DetailFormCommon.InventoryDetailFormSection>
                        </div>
                    </div>
                );
                break;
            }

            case LK.LookupKeys.StatusLevels: {
                lookupObjName = `${Formatters.getStr(curEditData, 'name')} (${Formatters.getStr(curEditData, 'statusId')})`;
                modalTitle = this.appText('modals.delete-lookup-obj.status-levels.title');
                modalNote = this.appText('modals.delete-lookup-obj.status-levels.note');
                modalSuccessButtonText = this.appText('modals.delete-lookup-obj.status-levels.delete-object');
                modalBody = (
                    <div>
                        <div className="lookup-tables-modal-delete-lookup-obj-warning-containter">
                            {modalNote}
                        </div>

                        <div>
                            {this.appText('modals.delete-lookup-obj.status-levels.note-2')}
                        </div>

                        <div>
                            <DetailFormCommon.InventoryDetailFormSection title="">
                                <KendoWrappers.KendoDisabledInputHidden
                                    name="deleteLookupObj.targetStatusId"
                                    label={this.appText('modals.delete-lookup-obj.status-levels.pending-deletion')}
                                    value={lookupObjName}
                                    {...inputProps}
                                />
                                <KendoWrappers.KendoDropdownListInput
                                    name="deleteLookupObj.destObjId"
                                    clearable={false}
                                    label={this.appText('modals.delete-lookup-obj.status-levels.choose-default-type')}
                                    value={_.get(this.state, 'editData.deleteAssocTypeDestId')}
                                    data={_.get(formData, 'options.statusLevels')}
                                    textField="text"
                                    valueField="value"
                                    onChange={(o) => {
                                        const newVal = _.get(o, 'target.value');
                                        let ed = _.get(this.state, 'editData');
                                        ed.deleteAssocTypeDestId = newVal;
                                        this.setState({ editData: ed });
                                    }}
                                    {...inputPropsVirtualizedSelect}
                                />
                            </DetailFormCommon.InventoryDetailFormSection>
                        </div>
                    </div>
                );
                break;
            }

            case LK.LookupKeys.Regions: {
                lookupObjName = `${Formatters.getStr(curEditData, 'name')} (${Formatters.getStr(curEditData, 'regionId')})`;
                modalTitle = this.appText('modals.delete-lookup-obj.regions.title');
                modalNote = this.appText('modals.delete-lookup-obj.regions.note');
                modalSuccessButtonText = this.appText('modals.delete-lookup-obj.regions.delete-object');
                modalBody = (
                    <div>
                        <div className="lookup-tables-modal-delete-lookup-obj-warning-containter">
                            {modalNote}
                        </div>

                        <div>
                            {this.appText('modals.delete-lookup-obj.regions.note-2')}
                        </div>

                        <div>
                            <DetailFormCommon.InventoryDetailFormSection title="">
                                <KendoWrappers.KendoDisabledInputHidden
                                    name="deleteLookupObj.targetRegionId"
                                    label={this.appText('modals.delete-lookup-obj.regions.pending-deletion')}
                                    value={lookupObjName}
                                    {...inputProps}
                                />
                                <KendoWrappers.KendoDropdownListInput
                                    name="deleteLookupObj.destObjId"
                                    clearable={false}
                                    label={this.appText('modals.delete-lookup-obj.regions.choose-default-type')}
                                    value={_.get(this.state, 'editData.deleteAssocTypeDestId')}
                                    data={_.get(formData, 'options.regions')}
                                    textField="text"
                                    valueField="value"
                                    onChange={(o) => {
                                        const newVal = _.get(o, 'target.value');
                                        let ed = _.get(this.state, 'editData');
                                        ed.deleteAssocTypeDestId = newVal;
                                        this.setState({ editData: ed });
                                    }}
                                    {...inputPropsVirtualizedSelect}
                                />
                            </DetailFormCommon.InventoryDetailFormSection>
                        </div>
                    </div>
                );
                break;
            }

            case LK.LookupKeys.ComponentLocations: {
                disabled = false;
                lookupObjName = `${Formatters.getStr(curEditData, 'name')} (${Formatters.getStr(curEditData, 'componentId')})`;
                modalTitle = this.appText('modals.delete-lookup-obj.component-locations.title');
                modalNote = this.appText('modals.delete-lookup-obj.component-locations.note');
                modalSuccessButtonText = this.appText('modals.delete-lookup-obj.component-locations.delete-object');
                modalBody = (
                    <div>
                        <div className="lookup-tables-modal-delete-lookup-obj-warning-containter">
                            {modalNote}
                        </div>

                        <div>
                            <DetailFormCommon.InventoryDetailFormSection title="">
                                <KendoWrappers.KendoDisabledInputHidden
                                    name="deleteLookupObj.targetComponentLocationsId"
                                    label={this.appText('modals.delete-lookup-obj.component-locations.pending-deletion')}
                                    value={lookupObjName}
                                    {...inputProps}
                                />
                            </DetailFormCommon.InventoryDetailFormSection>
                        </div>
                    </div>
                );
                break;
            }

            case LK.LookupKeys.InventoryTemplates: {
                disabled = false;
                lookupObjName = `${Formatters.getStr(curEditData, 'name')} (${Formatters.getStr(curEditData, 'templateId')})`;
                modalTitle = this.appText('modals.delete-lookup-obj.inventory-templates.title');
                modalNote = this.appText('modals.delete-lookup-obj.inventory-templates.note');
                modalSuccessButtonText = this.appText('modals.delete-lookup-obj.inventory-templates.delete-object');
                modalBody = (
                    <div>
                        <div className="lookup-tables-modal-delete-lookup-obj-warning-containter">
                            {modalNote}
                        </div>

                        <div>
                            <DetailFormCommon.InventoryDetailFormSection title="">
                                <KendoWrappers.KendoDisabledInputHidden
                                    name="deleteLookupObj.targetComponentLocationsId"
                                    label={this.appText('modals.delete-lookup-obj.inventory-templates.pending-deletion')}
                                    value={lookupObjName}
                                    {...inputProps}
                                />
                            </DetailFormCommon.InventoryDetailFormSection>
                        </div>
                    </div>
                );
                break;
            }

            case LK.LookupKeys.ComponentCategories: {
                lookupObjName = `${Formatters.getStr(curEditData, 'name')} (${Formatters.getStr(curEditData, 'categoryId')})`;
                modalTitle = this.appText('modals.delete-lookup-obj.component-categories.title');
                modalNote = this.appText('modals.delete-lookup-obj.component-categories.note');
                modalSuccessButtonText = this.appText('modals.delete-lookup-obj.component-categories.delete-object');
                modalBody = (
                    <div>
                        <div className="lookup-tables-modal-delete-lookup-obj-warning-containter">
                            {modalNote}
                        </div>

                        <div>
                            {this.appText('modals.delete-lookup-obj.component-categories.note-2')}
                        </div>

                        <div>
                            <DetailFormCommon.InventoryDetailFormSection title="">
                                <KendoWrappers.KendoDisabledInputHidden
                                    name="deleteLookupObj.targetComponentCategoryId"
                                    label={this.appText('modals.delete-lookup-obj.component-categories.pending-deletion')}
                                    value={lookupObjName}
                                    {...inputProps}
                                />
                                <KendoWrappers.KendoDropdownListInput
                                    name="deleteLookupObj.destObjId"
                                    clearable={false}
                                    label={this.appText('modals.delete-lookup-obj.component-categories.choose-default-type')}
                                    value={_.get(this.state, 'editData.deleteAssocTypeDestId')}
                                    data={_.get(formData, 'options.componentCategories')}
                                    textField="text"
                                    valueField="value"
                                    onChange={(o) => {
                                        const newVal = _.get(o, 'target.value');
                                        let ed = _.get(this.state, 'editData');
                                        ed.deleteAssocTypeDestId = newVal;
                                        this.setState({ editData: ed });
                                    }}
                                    {...inputPropsVirtualizedSelect}
                                />
                            </DetailFormCommon.InventoryDetailFormSection>
                        </div>
                    </div>
                );
                break;
            }

            default:
                modalBody = (<div />);
                break;
        }

        return (
            <Modal enforceFocus={false} show={this.state.showModalDeleteLookupObj} onHide={() => this.handleCloseModalDeleteLookupObj()}>
                <Modal.Header closeButton={true}>
                    <Modal.Title>{modalTitle}?</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {modalBody}
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle="success" disabled={disabled} onClick={(e) => this.handleConfirmRemove()}>{modalSuccessButtonText}</Button>
                    <Button bsStyle="danger" onClick={() => this.handleCloseModalDeleteLookupObj()}>{this.appTextCommon('buttons.cancel')}</Button>
                </Modal.Footer>
            </Modal>
        );
    }

    public transformLookupData(lookupDataRaw: any, curEditData: any, curEditId: any) {
        let ldr = _.cloneDeep(lookupDataRaw);

        let agd = _.get(this.state, 'additionalGridData');

        if (agd && !_.isEmpty(agd)) { ldr.unshift(agd); }

        let lookupDataTransformed = _.map(ldr, (r) => {
            let isEditing = (curEditId === Formatters.getStr(r, '_id')) ? true : false;

            let result = _.cloneDeep(r);

            if (isEditing) {
                const editFieldOption = _.stubObject();
                _.set(editFieldOption, this.GridEditField, isEditing);
                result = _.merge({}, r, curEditData, editFieldOption);
            }

            return result;
        });

        return lookupDataTransformed;
    }

    public showDetails(dataItem: any): boolean {
        const { lookups, tableName, ...rest } = this.props;

        let result = false;

        switch (tableName) {
            case 'inventoryTemplates':
                result = true;
                break;

            default:
                result = false;
                break;
        }

        return result;
    }

    public showDelete(dataItem: any): boolean {
        const { lookups, tableName, ...rest } = this.props;

        let result = true;

        switch (tableName) {
            case 'replacementCostTypes':
                if (Formatters.getInt(dataItem, 'replacementCostTypeId') === 1 || Formatters.getInt(dataItem, 'replacementCostTypeId') === 2) {
                    result = false;
                } else {
                    result = true;
                }

                break;

            default:
                result = true;
                break;
        }

        return result;
    }

    public hasAllValues = (dataItem: any, fields: Array<any>): boolean => _.every(fields, (o) => Formatters.getStr(dataItem, o) !== '');

    public render() {
        const { lookups, tableName, ...rest } = this.props;

        let lookupDataRaw = _.get(lookups, tableName, []);

        // if (!_.size(lookupDataRaw)) { return (<div />); }

        const curEditData = _.get(this.state, 'editData', {});
        const curEditId = Formatters.getStr(curEditData, '_id');

        let lookupDataTransformed = this.transformLookupData(lookupDataRaw, curEditData, curEditId);

        const appTextCol = (fieldName: string) => {
            return this.appText(`tables.${tableName}.${fieldName}`);
        };

        let gridProps: any = {};
        let gridCols = _.stubArray();

        switch (tableName) {
            case 'inventoryTemplateGroupComponents': {
                lookupDataTransformed = _.map(lookupDataTransformed, (o) => {
                    return _.merge(o, _.get(o, 'inventoryTemplateItems[0]'));
                });

                // console.log(`edit-child inventoryTemplateGroupComponents lookupDataTransformed`, { lookupDataTransformed });

                gridCols.push(this.getGridCol('templateId', appTextCol('templateId'), { width: '100px', editable: false, sortable: true }));
                gridCols.push(this.getGridCol('groupId', appTextCol('groupId'), { width: '100px', editable: true, sortable: true }));
                gridCols.push(this.getGridCol('componentId', appTextCol('componentId'), { width: '120px', editable: true, sortable: true }));
                gridCols.push(this.getGridCol('location', appTextCol('location'), { editable: true, sortable: true }));
                gridCols.push(this.getGridCol('quantity', appTextCol('quantity'), { width: '200px', editable: true, sortable: true }));
                gridCols.push(this.getGridCol('usefulLife', appTextCol('usefulLife'), { width: '120px', editable: true, sortable: true }));

                const canSave = (d: any) => !_.isEmpty(Formatters.getStr(d, 'location'));

                const editGridCommandCell = EditGridCommandCell(
                    (dataItem: any) => this.handleEnterEdit(dataItem),
                    (e: any, dataItem: any) => this.handleShowModalDeleteLookupObj(e, dataItem),
                    (dataItem: any) => this.handleSave(dataItem),
                    (dataItem: any) => this.handleCreate(dataItem),
                    (dataItem: any) => this.handleCancel(dataItem),
                    (dataItem: any) => undefined,
                    (dataItem: any) => this.showDetails(dataItem),
                    (dataItem: any) => this.showDelete(dataItem),
                    (dataItem: any) => canSave(dataItem),
                    this.GridEditField,
                    this.GridNewRecordField,
                    (m?: any, p?: any, t?: any) => this.appText(m, p, t));

                gridCols.push(this.getGridCol('', '', { width: '201px', cell: editGridCommandCell }));

                gridProps.sortable = true;
                const defaultGridSort = [{ field: 'componentId', dir: 'asc' }];
                const curStateGridSortRaw = _.get(this.state, 'gridSort', defaultGridSort);
                const curStateGridSort = (_.isEmpty(curStateGridSortRaw)) ? defaultGridSort : curStateGridSortRaw;
                gridProps.sort = (_.size(curStateGridSort) > 0) ? curStateGridSort : defaultGridSort;
                gridProps.sortChange = (e: any) => {
                    const eventGridSortRaw = _.get(e, 'sort', defaultGridSort);
                    const eventGridSortNext = (_.isEmpty(eventGridSortRaw)) ? defaultGridSort : eventGridSortRaw;
                    this.setState({ 'gridSort': eventGridSortNext });
                };

                lookupDataTransformed = orderBy(lookupDataTransformed, curStateGridSort);

                break;
            }

            default:
                break;
        }

        const buildFilteredOptionsStringValue = (lookupData: any, key: any, srcValueField: any = 'name', srcTextField: any = 'name', removeId: string = '_') => {
            const lData = _.get(lookupData, key, []);

            const l = _.reject(lData, (o) => Formatters.getStr(o, '_id') === removeId);

            if (_.size(l) <= 0) { return []; }

            return _.orderBy(l.map((c) => _.merge({}, { value: Formatters.getStr(c, srcValueField), text: Formatters.getStr(c, srcTextField) })), 'text');
        };

        let formData = {
            options: {
                associationTypes: buildFilteredOptionsStringValue(lookups, LK.LookupKeys.AssociationTypes, '_id', 'name', curEditId),
                clientTypes: buildFilteredOptionsStringValue(lookups, LK.LookupKeys.ClientTypes, '_id', 'name', curEditId),
                roofTypes: buildFilteredOptionsStringValue(lookups, LK.LookupKeys.RoofTypes, '_id', 'name', curEditId),
                fencingTypes: buildFilteredOptionsStringValue(lookups, LK.LookupKeys.FencingTypes, '_id', 'name', curEditId),
                sidingTypes: buildFilteredOptionsStringValue(lookups, LK.LookupKeys.SidingTypes, '_id', 'name', curEditId),
                securedTypes: buildFilteredOptionsStringValue(lookups, LK.LookupKeys.SecuredTypes, '_id', 'name', curEditId),
                recRoomTypes: buildFilteredOptionsStringValue(lookups, LK.LookupKeys.RecRoomTypes, '_id', 'name', curEditId),
                componentCategories: buildFilteredOptionsStringValue(lookups, LK.LookupKeys.ComponentCategories, '_id', 'name', curEditId),
                statusLevels: buildFilteredOptionsStringValue(lookups, LK.LookupKeys.StatusLevels, '_id', 'name', curEditId),
                regions: buildFilteredOptionsStringValue(lookups, LK.LookupKeys.Regions, '_id', 'name', curEditId),
            }
        };

        // console.log(formData);

        const gridDataSource = process(lookupDataTransformed, {});

        const addNewButtonDisabled = this.handleAddNewButtonDisabled(tableName);

        const grid = (
            <Grid
                data={gridDataSource}
                resizable={true}
                editField={this.GridEditField}
                itemChange={(e) => { this.handleGridItemChange(e); }}
                {...gridProps}
            >
                <GridToolbar>
                    <Button
                        bsSize="xs"
                        bsStyle="success"
                        onClick={(e) => this.handleAddNewButton(e)}
                        disabled={addNewButtonDisabled}
                    >
                        <i className="glyphicon glyphicon-plus" />  {this.appTextCommon('buttons.new')}
                    </Button>
                </GridToolbar>
                {_.map(gridCols, (c, i) => this.renderGridCol(c, i))}
            </Grid>
        );

        const pageTitle = this.appTextPageTitleAppendString(tableName, 'lookup-table', true);
        const page = (
            <div>
                <Row>
                    <Col xs={12} xl={9}>
                        <div>
                            {this.renderHeaderButtonToolbar()}
                            {this.renderModalDeleteLookupObj(formData)}
                        </div>
                    </Col>
                </Row>
                <WhiteBoxPageSection title={pageTitle}>
                    {/* Header toolbar */}
                    <Row>
                        <Col xs={12}>
                            {grid}
                        </Col>
                    </Row>
                </WhiteBoxPageSection>
            </div>
        );

        return (
            <AppComp.RenderPageWithLayout branding={this.props.branding} pageName={pageTitle} {...this.props}>
                {page}
            </AppComp.RenderPageWithLayout>
        );
    }
}

const getApiUrlLookups = (props) => ApiEndpoints.getLookupsByKeyWithChildObjIdUrl(props.match.params.tableName, props.match.params.childObjId);

const mapPropsToConfigs = (props) => {
    return ReduxQueries.Queries.getLookupsByKeyRequest(
        getApiUrlLookups(props),
        ReduxQueries.PropsAccessToken(props)
    );
};

const mapStateToProps = (state, props) => {
    const tableName = Formatters.getStr(props, 'match.params.tableName');
    const childObjId = Formatters.getStr(props, 'match.params.childObjId');

    return ReduxQueries.MapQueryStateToPropsByUrl(getApiUrlLookups(props), state, props, {
        tableName: tableName,
        childObjId: childObjId,
    });
};

const mapDispatchToProps = {
    updateLookupObj: MutateActions.updateLookupObjMutateAsync,
    newLookupObj: MutateActions.newLookupObjMutateAsync,
    deleteLookupObj: MutateActions.deleteLookupObjMutateAsync,
    navigateTo: (path) => push(path),
};

const EditLookupTableContainer = compose<any>(
    connect(mapStateToProps, mapDispatchToProps),
    connectRequest(mapPropsToConfigs)
)(EditChildLookupTable);

export default withRouter(EditLookupTableContainer);



// WEBPACK FOOTER //
// ./src/lookup-tables/edit-child.tsx